import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { addFoodToFavourite } from '../../redux/features/WishList/wishlistSlice';
import AddQuantityModal from '../Restaurent/AddQuantityModal';
import { addCartItem, removeCartItem } from '../../redux/features/Cart/CartSlice';
const FavouriteItems = () => {
    const wishlist = useSelector((state) => state.wishlist.wishlist);
    const cartdata = useSelector((state) => state.cart.cart);
    const dispatch = useDispatch();
    const [modelItem, setModelItem] = useState({});

    const handleAddCart = (item) => {
        dispatch(addCartItem(item));
    };

    const handleRemoveCart = (item) => {
        dispatch(removeCartItem(item));
    };
    // Handle Add to favourite
    const handleAddFoodToWishlist = async (menu) => {
        try {
            dispatch(addFoodToFavourite(menu))
        } catch (error) {
        }
    }

    return (
        <>
            {
                wishlist?.length > 0 ? (
                    wishlist.map((wish, index) => {
                        return (
                            <div key={wish.id} className="col-lg-6 col-md-6 col-sm-6">
                                <div className="recommended-card">
                                    <div className="recommended-img">
                                        <img src={wish.images} alt="recommended01" />
                                        <span className="food-type">
                                            <i className="fas fa-circle" />
                                        </span>
                                        <button onClick={() => handleAddFoodToWishlist(wish)} className="fav-btn">
                                            <i className={wishlist.some((item) => item.id === wish.id) ? "fas fa-heart text-danger" : "far fa-heart"} />
                                        </button>
                                    </div>
                                    <div className="recommended-content">
                                        <h5>Chola Paneer</h5>
                                        <p className="dtl-rating">
                                            <span className="rating">
                                                <i className="fas fa-star me-1" />
                                                {wish.rating}{" "}
                                            </span>
                                            {" "}{wish.updated_rating} Ratings
                                        </p>
                                        <p>
                                            {wish.item_name}
                                        </p>
                                        <div className="recommended-bttm">
                                            <h6 className="mb-0">₹ {wish.item_price}</h6>
                                            {/* <Link to="" className="thm-btn fill-btn" data-bs-toggle="modal" data-bs-target="#add-quantity">
                                                Add
                                            </Link> */}
                                            {cartdata.some((arr) => arr?.cartItem.id === wish?.id) ? (
                                                <div className="quantity">
                                                    <button
                                                        type="button"
                                                        className="minus"
                                                        onClick={() => handleRemoveCart(wish)}
                                                    >
                                                        <i className="fas fa-minus" />
                                                    </button>
                                                    <input className="number" type="number" disabled
                                                        value={
                                                            cartdata.find(
                                                                (arr) => arr.cartItem.id === wish.id
                                                            )?.itemQuantity
                                                        }
                                                    />
                                                    <button type="button" className="plus" onClick={() => handleAddCart(wish)}>
                                                        <i className="fas fa-plus" />
                                                    </button>
                                                </div>
                                            ) : (
                                                <Link
                                                    to=""
                                                    className="thm-btn fill-btn"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#add-quantity"
                                                    onClick={() => setModelItem(wish)}
                                                >
                                                    Add To Cart
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <p className='text-center text-danger'>No Items Found</p>
                )
            }
            <AddQuantityModal
                modelItem={modelItem}
                cartdata={cartdata}
                handleAddCart={handleAddCart}
                handleRemoveCart={handleRemoveCart}
            />
        </>
    )
}

export default FavouriteItems